import React, { useState, useEffect, lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import ScrollToTop from "./components/scrolltotop";
import WhatsAppButton from "./components/whatsapp";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GoogleAnalytics from "./components/google-analytics";
import QuoteRequestModal from "./components/get-quote/QuoteRequestModal";

// React.lazy dynamic loaders for code splitting & Performance Optimization
const Home = lazy(() => import("./components/home"));
const About = lazy(() => import("./components/about"));
const Gallery = lazy(() => import("./components/gallery"));
const Contact = lazy(() => import("./components/contact"));
const OurStory = lazy(() => import("./components/our-story"));
const LionCollecton = lazy(() => import("./components/lion-collection"));
const HorseCollection = lazy(() => import("./components/horse-collection"));
const CowCollection = lazy(() => import("./components/cow-collection"));
const GodStatueCollection = lazy(() => import("./components/God-statues-collection"));
const ElephantCollection = lazy(() => import("./components/elephant-collection"));
const CreativeCollection = lazy(() => import("./components/creative-collection"));
const DogCollection = lazy(() => import("./components/dog-collection"));
const PanelCollection = lazy(() => import("./components/panel-collection"));
const TortoiseCollection = lazy(() => import("./components/tortoise-collection"));
const MordernArtCollection = lazy(() => import("./components/mordern-art-collection"));
const MasterPeicesCollection = lazy(() => import("./components/master-peices-collection"));

function App() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quoteData, setQuoteData] = useState({});

  useEffect(() => {
    const handler = (e) => {
      const d = e.detail || {};
      setQuoteData({
        productImage: d.currentImage || d.productImage || (d.card && d.card.images && d.card.images[0]) || null,
        productId: d.productId || d.card?.id || null,
      });
      setQuoteOpen(true);
    };

    window.addEventListener("openQuote", handler);
    return () => window.removeEventListener("openQuote", handler);
  }, []);
  return (
    <HelmetProvider>
    <Router>
      <GoogleAnalytics />
      <Navbar />
      <ScrollToTop />
      <Suspense fallback={
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
          fontFamily: "'Playfair Display', serif",
          fontSize: "20px",
          color: "#7a5c3d"
        }}>
          Loading...
        </div>
      }>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/lion-collection" element={<LionCollecton />} />
          <Route path="/horse-collection" element={<HorseCollection />} />
          <Route path="/cow-collection" element={<CowCollection />} />
          <Route path="/god-collection" element={<GodStatueCollection />} />
          <Route path="/elephant-collection" element={<ElephantCollection />} />
          <Route path="/panel-collection" element={<PanelCollection />} />
          <Route path="/dog-collection" element={<DogCollection />} />
          <Route path="/modern-art-collection" element={<MordernArtCollection />} />
          <Route path="/tortoise-collection" element={<TortoiseCollection />} />
          <Route path="/master-collection" element={<MasterPeicesCollection />} />
          <Route path="/creative-collection" element={<CreativeCollection />} />
        </Routes>
      </Suspense>
      <WhatsAppButton />
      <QuoteRequestModal
        isOpen={quoteOpen}
        onClose={() => setQuoteOpen(false)}
        productImage={quoteData.productImage}
        productId={quoteData.productId}
        submitUrl={process.env.REACT_APP_QUOTE_PROXY || 'http://localhost:4000/quote'}
      />
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        pauseOnHover
        draggable
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
      />
      <Footer />
    </Router>
    </HelmetProvider>
  );
}

export default App;
